<template>
  <span
    class="chat-avatar"
    :style="{ width: `${size}px`, height: `${size}px`, background: color, fontSize: `${Math.round(size * 0.38)}px` }"
  >
    <img
      v-if="showPhoto"
      class="chat-avatar__img"
      :src="src"
      :alt="name"
      loading="lazy"
      @error="failed = true"
    >
    <template v-else>
      {{ text }}
    </template>
    <i
      v-if="status"
      class="chat-avatar__dot"
      :class="`chat-avatar__dot--${status}`"
      :style="{ width: `${Math.max(10, size * 0.28)}px`, height: `${Math.max(10, size * 0.28)}px` }"
    />
  </span>
</template>

<script>
import { initials, avatarColor, resolvePhoto } from '@/utils/chat'

export default {
  name: 'ChatAvatar',

  props: {
    name: { type: String, default: '' },
    size: { type: Number, default: 44 },
    // operating | idle | paused | offline — sem valor, não mostra a bolinha
    status: { type: String, default: null },
    // Foto de perfil; sem foto (ou se ela falhar ao carregar) cai nas iniciais.
    photo: { type: String, default: null },
  },

  data() {
    return { failed: false }
  },

  computed: {
    src() {
      return resolvePhoto(this.$store.state.url, this.photo)
    },
    showPhoto() {
      return !!this.src && !this.failed
    },
    text() {
      return initials(this.name)
    },
    color() {
      return avatarColor(this.name)
    },
  },

  watch: {
    photo() {
      this.failed = false
    },
  },
}
</script>

<style scoped>
.chat-avatar__img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
}

.chat-avatar {
  position: relative;
  display: inline-flex;
  flex: none;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: #fff;
  font-weight: 600;
  letter-spacing: 0.02em;
  user-select: none;
}

.chat-avatar__dot {
  position: absolute;
  right: -1px;
  bottom: -1px;
  border: 2px solid var(--chat-surface, #fff);
  border-radius: 50%;
  background: #b9b9c3;
}

.chat-avatar__dot--operating { background: #28c76f; }
.chat-avatar__dot--idle { background: #ff9f43; }
.chat-avatar__dot--paused { background: #ea5455; }
</style>
